import { useEffect, useState } from 'react';

export default function useNetworkStatus() {
  const [isOnline, setIsOnline] = useState<boolean>(navigator.onLine);
  const [prevStatus, setPrevStatus] = useState<boolean>(navigator.onLine);

  useEffect(() => {
    const handleNetworkChange = () => {
      setIsOnline((prev) => {
        setPrevStatus(prev);
        return navigator.onLine;
      });
    };

    window.addEventListener('online', handleNetworkChange);
    window.addEventListener('offline', handleNetworkChange);

    return () => {
      window.removeEventListener('online', handleNetworkChange);
      window.removeEventListener('offline', handleNetworkChange);
    };
  }, []);

  return [isOnline, prevStatus] as const;
}
